export const activity = {
  activityWebEmptyStateTitle: 'Ingen aktivitet ännu',
  activityWebEmptyStateText: 'Här kommer din meddelandefeed att vara',
  activitySeeAll: 'Se allt',
  in: 'i'
}
